export const styles = {
  container: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },

  stack: {
    borderRadius: '8px',
    height: '54px',
    border: 'solid 1px',
    borderColor: 'grey.300',
    width: '100%',
    gap: '24px',
    left: '40px',
    paddingTop: '6px',
    paddingLeft: '6px',
    mb: 4,
  },

  toggleButton: {
    height: 42,
    padding: '10px',
    border: 0,
  },

  toggleButtonIcon: {
    height: '18px',
    width: '18px',
  },

  myCard: {
    mb: 3,
    pb: 5,
    height: '100%',
    width: 354,
    position: 'relative',
    justifyContent: 'center',
  },

  avatarArch: {
    width: 200,
    height: 82,
    zIndex: 9,
    top: 49,
    left: 77,
    position: 'absolute',
    color: 'background.paper',
  },

  avatar: {
    zIndex: 9,
    top: 53,
    left: 129,
    width: 96,
    height: 96,
    position: 'absolute',
  },

  placeholder: {
    width: 96,
    height: 96,
  },

  name: {
    color: 'grey.800',
    marginTop: 8,
    textAlign: 'center',
  },

  role: {
    color: 'grey.600',
    textAlign: 'center',
    marginBottom: 3,
    textTransform: 'capitalize',
  },

  box: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    margin: '40px 41px 0px 41px',
  },

  phone: {
    color: 'primary.main',
    position: 'relative',
    textAlign: 'right',
  },

  email: {
    color: 'primary.main',
    position: 'relative',
    textAlign: 'right',
  },

  editButton: {
    width: '274px',
    height: '36px',
    radius: '8px',
    marginTop: '33px',
  },

  tooltipIcon: {
    mr: '6px',
  },

  text: {
    marginLeft: '8px',
  },

  dropdownIcon: {
    width: '20px',
    height: '20px',
    ml: '28px',
    mr: '-8px',
  },

  dropdown: {
    pl: '0px',
    pr: '0px',
    width: '220px',
    height: '151px',
  },

  menuItem: {
    mt: '3px',
    mb: '3px',
    ml: '8px',
  },

  divider: {
    mt: '8px',
    mb: '10px',
  },
};
